export const useGtm = () => {
  if (!process.client) {
    // Return a mock object for SSR
    return {
      trackEvent: () => {},
      trackView: () => {},
    };
  }

  const nuxtApp = useNuxtApp();
  return nuxtApp.$gtm;
};
